'use strict';
module.exports = require('./Message.vue');